import { z } from 'zod';
import { parseWebApiResponse } from './common';
export const propertyMapAvailabilityResponseSchema = z.object({ available: z.boolean() });
export function parsePropertyMapAvailabilityResponse(data) {
    return parseWebApiResponse(propertyMapAvailabilityResponseSchema, data, 'property map availability');
}
export const propertyMapViewerResponseSchema = z.discriminatedUnion('status', [
    z.object({ status: z.literal('unavailable') }),
    z.object({
        status: z.literal('ready'),
        propertyName: z.string(),
        demo: z.boolean(),
        imageUrl: z.string().url().nullable().optional(),
        shareEnabled: z.boolean().optional(),
        mapId: z.string(),
        browserApiKey: z.string().min(1),
        units: z.array(z.object({
            id: z.string(),
            name: z.string(),
            floorId: z.string(),
            shareUnitNumber: z.string().nullable().optional(),
        })),
        selectedUnitId: z.string().nullable(),
    }),
]);
export const propertyMapShareResponseSchema = z.discriminatedUnion('success', [
    z.object({
        success: z.literal(true),
        mapKind: z.literal('property_site_map'),
        demo: z.boolean(),
        shareUrl: z.string().url(),
        imageUrl: z.string().url().optional(),
        unitNumber: z.string().optional(),
    }),
    z.object({ success: z.literal(false), reason: z.enum(['not_available', 'unit_not_mapped']) }),
]);
export function parsePropertyMapShareResponse(data) {
    return parseWebApiResponse(propertyMapShareResponseSchema, data, 'property map share link');
}
export function parsePropertyMapViewerResponse(data) {
    return parseWebApiResponse(propertyMapViewerResponseSchema, data, 'property map');
}
